import React from 'react';
import classnames from 'classnames';
import { Text } from '@leverege/ui-elements';
import S from './ColumnText.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function LabelText(props) {
  const {
    variant
  } = props;
  return create(variant || 'columnLabel', '--color-columnLabel', S.label, props);
}
export function ValueText(props) {
  const {
    variant
  } = props;
  return create(variant || 'columnValue', '--color-columnValue', S.value, props);
}
export function SuffixText(props) {
  const {
    variant
  } = props;
  return create(variant || 'columnSuffix', '--color-columnSuffix', S.suffix, props);
}
function create(variant, colorVar, cn, props) {
  const {
    className,
    style,
    children,
    variant: oVariant,
    ...rest
  } = props;
  let s = style;
  if (s?.color) {
    s = {
      [colorVar]: s.color,
      ...s
    };
  }
  let ch = children;
  if (Array.isArray(ch)) {
    if (ch.some(i => i != null && typeof i === 'object')) {
      ch = null;
    }
  } else if (ch && typeof ch === 'object') {
    ch = null;
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: oVariant || variant,
    style: s,
    className: classnames(cn, className),
    ...rest,
    children: ch
  });
}